import * as React from 'react';
import { Select } from 'antd';
export const Processes = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { size: "small", dropdownMatchSelectWidth: false, style: {
                maxWidth: 400,
            }, ...props },
            React.createElement(Select.Option, { value: "CNC" }, "CNC"),
            React.createElement(Select.Option, { value: "3D PRINTING" }, "3D Printing"))));
};
